module.exports = __webpack_public_path__ + "img/M007-09_jrb-01.4620d5cb.jpg";